import { Flex, Link } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { Provider } from '@prisma/client';

import { SimpleCheckbox } from './SimpleCheckbox';

export const TermsAndConditions = ({ provider }: { provider: Provider }) => {
  const terms = provider?.terms_conditions_url;

  return (
    <Flex>
      <SimpleCheckbox
        name="terms"
        label={terms ? 'By checking, I accept the' : 'By checking, I accept the airline conditions of contract'}
        variant="unstyled"
      />
      <Show if={!!terms}>
        &nbsp;
        <Link href={terms} target="_blank" color="primary.600">
          airline conditions of contract
        </Link>
      </Show>
    </Flex>
  );
};
